<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印退料单"
      width="900px"
      class="printOutStockOrder">
    <div id="printProductionPicking" :loading="contentLoading">
      <div v-for="(item, index) in outStockBillVOS" :key="index" style="page-break-before: always;margin-bottom:10px">
        <table class="codeBox" cellspacing="0" style="width:100%">
          <tr>
            <td rowspan="3" style="padding:5px">
              <div :id="'qrCode' + item.billNo" align="center"/>
            </td>
            <td colspan="5" style="text-align: center; font-weight: 700; font-size: 14px">退料单</td>
          </tr>
          <tr>
            <td colspan="2" style="width:30%">退料单号：{{item.billNo}}</td>
            <td colspan="2" style="width:30%">关联单号：{{item.relBillNo}}</td>
            <td>退料类型：{{item.inStockTypeName}}</td>
          </tr>
          <tr>
            <td colspan="2">退料时间：{{item.receiptDate}}</td>
            <td colspan="3">备注：{{item.note}}</td>
          </tr>
          <tr>
            <td style="width:150px;">物料编号</td>
            <td colspan="3">物料名称</td>
            <td style="width:10%;text-align:center;">数量</td>
            <td>库位</td>
          </tr>
          <tr v-for="(i,index1) in item.details" :key="index1">
            <td style="width:150px;">{{i.materialNo}}</td>
            <td colspan="3">{{i.materialName}}</td>
            <td style="width:10%;text-align:center;">{{i.quantity}}</td>
            <td>{{i.locationName}}</td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        outStockBillVOS: [
          {
            billNo: "",
            outStockTypeName: "",
            requireDate: "",
            relBillNo: "",
            note: "",
            details: [],
          },
        ],
      };
    },

    methods: {
      open(ids) {
        this.dialogVisible = true;
        this.getData(ids);
      },

      getData(ids) {
        this.contentLoading = true;
        this.$http.get("basic", `inStockBills/getAllListByIds/${ids}`).then((resp) => {
          console.log(resp);
          this.outStockBillVOS = resp.data;
          for (let item of this.outStockBillVOS) {
            this.$nextTick(() => {
              document.getElementById("qrCode" + item.billNo).innerHTML = "";
              this.bindQRCode(item.billNo);
            });
          }
          this.contentLoading = false;
        });
      },

      bindQRCode(billNo) {
        let text = billNo;
        new QRCode(document.getElementById("qrCode" + billNo), {
          text: text,
          width: 120,
          height: 120,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        document.body.innerHTML = document.getElementById("printProductionPicking").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>

<style scoped>
/* 正文样式 */
table {
  width: 100%;
  font-size: 10px;
}

table td {
  border: 1px solid #111;
  border-right: 0;
  border-top: 0;
  padding: 0 5px;
  height: 30px;
}

table tr td:last-child {
  border-right: 1px solid #111;
}

table tr:first-child td {
  border-top: 1px solid #111;
}
</style>

<style>
.printOutStockOrder .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.printOutStockOrder .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.printOutStockOrder .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.printOutStockOrder .el-divider--horizontal {
  margin: 10px 0;
}

.printOutStockOrder .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>